import { css } from '@emotion/css';
import { primary, N0 } from '@/colors/colorsV1';

export const styTooltipMarker = (props) => css`
  position: absolute;
  background: ${N0};
  height: 16px;
  width: 16px;
  border-radius: 2px;

  ${(props.position === 'top' || props.position === 'top-left') &&
  'bottom: 0px; transform: translateY(45%) rotate(45deg);'}
  ${props.position === 'top-right' &&
  'bottom: 0px; right: 0px; transform: translate(-120%,45%) rotate(45deg);'}
  ${(props.position === 'bottom' || props.position === 'bottom-left') &&
  'top: 0px; transform: translateY(-45%) rotate(45deg);'}
  ${props.position === 'bottom-right' &&
  'top: 0px; right: 0px; transform: translate(-120%,-45%) rotate(45deg);'}
  ${props.position === 'left' && 'right: 0px; transform: translateX(45%) rotate(45deg);'}
  ${props.position === 'right' && 'left: 0px; transform: translateX(-45%) rotate(45deg);'}
`;

export const styAlignRight = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
